export const imageMaxSize =  6291456; //6 MB